import { render, staticRenderFns } from "./ConnectStrava.vue?vue&type=template&id=028f0100&scoped=true"
import script from "./ConnectStrava.vue?vue&type=script&lang=js"
export * from "./ConnectStrava.vue?vue&type=script&lang=js"
import style0 from "./ConnectStrava.vue?vue&type=style&index=0&id=028f0100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028f0100",
  null
  
)

export default component.exports